import React, { PropTypes } from 'react';
import { Helmet } from 'react-helmet';
import { branch, compose, renderComponent } from 'recompose'
import { withRouter } from 'react-router';
import { withAuth } from 'store/auth/withAuth';
import { withPreferences } from 'store/preferences/withPreferences';
import withStoreTheme from 'store/theme/withStoreTheme'
import withTheme from 'hocs/bases/withTheme';

import inCartApi from 'apis/incartApis'
import cmsApis from 'apis/cmsApis'

import BluePrintRenderer from 'components/Canvas/renderer';
import { Loader } from 'semantic-ui-react'
import Container from 'components/Container'
import withIntl from 'store/intl/withIntl'
import { CMS_DEFAULT_IMAGE } from 'helpers/constants'

const Loading = () => <Loader active size="big">Loading...</Loader>

class RenderPage extends React.Component {
  constructor() {
    super()
    this.state = {
      bluePrint: null,
      isLoading: false,
      isCanvasPreviewerOpened: false,
      canvas: null,
    }
    this.receiveMessage = this.receiveMessage.bind(this)
    window.switchLanguage = this.switchLanguage.bind(this)
    window.addEventListener('message', this.receiveMessage, false)
  }
  receiveMessage(e) {
    const { pageId = null, isCanvasPreviewerOpened = false, canvas } = e.data
    // dont open redux dev tool
    // preview while edit wont work because redux dev tool use postMessage too
    if (
      this.state.isCanvasPreviewerOpened !== isCanvasPreviewerOpened &&
      e.origin === window.location.origin
    ) {
      this.setState({ isCanvasPreviewerOpened, canvas })
    }
    if (pageId && e.origin === window.location.origin) {
      this.setState({ isLoading: true })
      cmsApis.getPageById(pageId)
        .then(({ data }) => this.setState({ isLoading: false, bluePrint: data }))
        .catch((error) => this.setState({ isLoading: false, bluePrint: error }))
    }
  }

  switchLanguage(language = 'en') {
    this.props.switchLanguage(language)
  }

  render() {
    const {
      isLoading,
      bluePrint,
      isCanvasPreviewerOpened,
      canvas,
    } = this.state
    const {
      preferences,
    } = this.props
    if ((isLoading || !bluePrint) && !isCanvasPreviewerOpened) {
      return (
        <Loading />
      )
    } else if (bluePrint && bluePrint.error && !isCanvasPreviewerOpened) {
      return (
        <Container>
          Fail!
        </Container>
      )
    }
    return (
      <div>
        <Helmet>
          <link rel="stylesheet" type="text/css" href={preferences.css} />
        </Helmet>
        <BluePrintRenderer
          bluePrint={isCanvasPreviewerOpened ? canvas : bluePrint}
          router={null}
          assets={{
            defaultImage: CMS_DEFAULT_IMAGE,
            attributeRule: [],
          }}
          api={{
            fetchProductDetail: inCartApi.getProduct,
            fetchProductList: inCartApi.getProductList,
            fetchMenuDetail: cmsApis.getMenus,
          }}
        />
      </div>
    )
  }
}

RenderPage.propTypes = {
  preferences: PropTypes.object.isRequired,
  switchLanguage: PropTypes.func.isRequired,
}

RenderPage.defaultProps = {}

export default compose(
  withAuth(),
  withPreferences(),
  branch(
    ({ observeForAuthStatus, fetchPreferencesStatus }) => (
      !observeForAuthStatus.isSuccess || !fetchPreferencesStatus.isSuccess
    ),
    renderComponent(Loading),
  ),
  withStoreTheme(),
  withTheme,
  withRouter,
  withIntl(),
)(RenderPage);



// WEBPACK FOOTER //
// ./src/pages/CustomPages/children/RenderPage.js